var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71967 22.4697C7.01256 22.1768 7.48744 22.1768 7.78033 22.4697L10.75 25.4393L13.7197 22.4697C14.0126 22.1768 14.4874 22.1768 14.7803 22.4697C15.0732 22.7626 15.0732 23.2374 14.7803 23.5303L11.2803 27.0303C10.9874 27.3232 10.5126 27.3232 10.2197 27.0303L6.71967 23.5303C6.42678 23.2374 6.42678 22.7626 6.71967 22.4697Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 4.75C11.1642 4.75 11.5 5.08579 11.5 5.5V26.5C11.5 26.9142 11.1642 27.25 10.75 27.25C10.3358 27.25 10 26.9142 10 26.5V5.5C10 5.08579 10.3358 4.75 10.75 4.75Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7197 4.96967C21.0126 4.67678 21.4874 4.67678 21.7803 4.96967L25.2803 8.46967C25.5732 8.76256 25.5732 9.23744 25.2803 9.53033C24.9874 9.82322 24.5126 9.82322 24.2197 9.53033L21.25 6.56066L18.2803 9.53033C17.9874 9.82322 17.5126 9.82322 17.2197 9.53033C16.9268 9.23744 16.9268 8.76256 17.2197 8.46967L20.7197 4.96967Z",
    fill: "#383733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 4.75C21.6642 4.75 22 5.08579 22 5.5V26.5C22 26.9142 21.6642 27.25 21.25 27.25C20.8358 27.25 20.5 26.9142 20.5 26.5V5.5C20.5 5.08579 20.8358 4.75 21.25 4.75Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.fb3db716fd368b0fdd47c931363b4a7a.svg";
export { ForwardRef as ReactComponent };